export default __webpack_public_path__ + "static/media/2.0c2f0ffc.png";